import { BindingPath } from "../../../../Engine/Core/CoreTypes";

import { InstanceNumberAction, InstanceNumberActionType } from "./instanceNumberActions";

export function addInstanceNumber(bindingPath: BindingPath, instanceNumber: number): InstanceNumberAction {
    return {
        type: InstanceNumberActionType.AddInstanceNumber,
        payload: {
            bindingPath: bindingPath,
            instanceNumber: instanceNumber,
        },
    };
}

export function removeInstanceNumber(bindingPath: BindingPath): InstanceNumberAction {
    return {
        type: InstanceNumberActionType.RemoveInstanceNumber,
        payload: {
            bindingPath: bindingPath,
        },
    };
}
